import type { FC } from 'react';
import { Tearsheet } from '@carbon/ibm-products';
import { wellboreGeometryBase } from 'types/wellbore-geometry-workspace';
import { PreDrillWorkspaceShell } from './pre-drill-workspace-shell';
import styles from './wellbore-geometry-tearsheet.module.scss';

export interface WellboreGeometryTearsheetProps {
  /** The bore to show; null keeps the body unmounted. */
  uwi14: string | null;
  /** The Well Workspace the sheet was opened from. */
  wellWorkspaceId: number | null;
  open: boolean;
  onClose: () => void;
  /** The well the sheet was opened for, named in its own header. */
  wellName?: string | null;
}

/**
 * The Wellbore Geometry Workspace as a tearsheet over a Well Workspace (Story 7 of
 * INS-10690), hosting the existing workspace body read at the bore's own address. The
 * host re-reads its Wellbores on close so a saved geometry shows its new source.
 * @param {WellboreGeometryTearsheetProps} props The bore, open state and close.
 * @return {JSX.Element} The tearsheet.
 */
export const WellboreGeometryTearsheet: FC<WellboreGeometryTearsheetProps> = ({
  uwi14,
  wellWorkspaceId,
  open,
  onClose,
  wellName,
}) => (
  <Tearsheet
    open={open}
    onClose={onClose}
    className={styles.tearsheet}
    title="Wellbore Geometry"
    hasCloseIcon
    closeIconDescription="Close"
  >
    {open && uwi14 && wellWorkspaceId !== null && (
      <div className={styles.body}>
        <PreDrillWorkspaceShell
          href={wellboreGeometryBase(wellWorkspaceId, uwi14)}
          onLeave={onClose}
          embedded
          wellName={wellName}
          wellWorkspaceId={wellWorkspaceId}
        />
      </div>
    )}
  </Tearsheet>
);
